import { RESET_PASSWORD_URL } from '~/configs/page-url'
import { useLogin } from '~/composables/account/use-login'

export function useLangdingPageLogin() {
  onMounted(async () => {
    const { handleSubmit } = useLogin()
    const route = useRoute()
    const ignorePaths: string[] = [RESET_PASSWORD_URL, '/account']
    const lpToken = route.query?.token
    const redirect = route.query
    if (lpToken && !ignorePaths.includes(route.path)) {
      await handleSubmit(lpToken, redirect)
    }
  })
}
